import { render, staticRenderFns } from "./originality.vue?vue&type=template&id=038f3f4e&scoped=true"
import script from "./originality.vue?vue&type=script&lang=js"
export * from "./originality.vue?vue&type=script&lang=js"
import style0 from "./originality.vue?vue&type=style&index=0&id=038f3f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f3f4e",
  null
  
)

export default component.exports